// Informational clock only: never reserves inventory, changes prices or clears a cart.
if (!customElements.get('cp-cart-countdown')) {
  customElements.define('cp-cart-countdown', class extends HTMLElement {
    connectedCallback() {
      this.key = `cp-cart-clock-${this.dataset.theme}-${this.dataset.minutes}`;
      this.clock = this.querySelector('.cp-cart-clock');
      if (Number(this.dataset.count) === 0) {
        try { sessionStorage.removeItem(this.key); } catch {}
        return;
      }
      let stored;
      try { stored = Number(sessionStorage.getItem(this.key)); } catch {}
      this.deadline = stored || Date.now() + Math.max(1, Number(this.dataset.minutes) || 10) * 60000;
      if (!stored) { try { sessionStorage.setItem(this.key, String(this.deadline)); } catch {} }
      this.tick = () => {
        const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        this.clock.textContent = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
        if (!seconds) {
          clearInterval(this.timer);
          const message = this.parentElement.querySelector('.cp-cart-message');
          if (message) message.textContent = 'Votre panier reste disponible';
        }
      };
      this.tick();
      if (this.deadline > Date.now()) this.timer = setInterval(this.tick, 1000);
      document.addEventListener('visibilitychange', this.tick);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.tick);
    }
  });
}
